/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { fonts, themes } from '../../../common/themes/themes';
import './OffBoarding.css';
import OffBoardingFormController from '../../../domain/myProfile/offBoarding/OffBoardingForm/OffBoardingFormController';
import OffBoardingHistoryController from '../../../domain/myProfile/offBoarding/OffBoardingHistory/OffBoardingHistoryController';
import OffBoardingWorkflowController from '../../../domain/myProfile/offBoarding/OffBoardingWorkflow/OffBoardingWorkflowController';
import Loader from '../../../common/Lottifiers/Loader/Loader';
import { useAppSelector } from '../../../infra/hooks';

interface PropsValue {
  storeOffboardingList: any;
  trans?: any;
  i18n?: any;
}
const OffBoardingPresenter: React.FC<PropsValue> = ({
  storeOffboardingList,
  trans,
  i18n,
}) => {
  const [showForm, setShowForm] = useState<any>(false);
  const [showHistory, setShowHistory] = useState<any>(false);
  const [showWorkflow, setShowWorkflow] = useState<any>(false);

  const isLoading = useAppSelector((state) => state.LoaderSlice.Loading);
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);

  useEffect(() => {
    if (storeOffboardingList?.status == 2) {
      setShowForm(true);
      setShowWorkflow(false);
      setShowHistory(true);
    } else if (storeOffboardingList?.status == 4) {
      setShowForm(true);
      setShowWorkflow(false);
      setShowHistory(true);
    } else if (
      storeOffboardingList?.status == 1 ||
      storeOffboardingList?.status == 0
    ) {
      setShowForm(false);
      setShowWorkflow(true);
      setShowHistory(true);
    } else {
      setShowForm(true);
      setShowHistory(false);
      setShowWorkflow(false);
    }
  }, [storeOffboardingList, isLoading]);

  return (
    <Grid
      container
      style={{
        display: 'flex',
        flexWrap: 'nowrap',
        marginTop: isHRView ? '' : '4em',
        width: '100vw',
        paddingRight: '8em',
      }}
    >
      <Grid
        item
        xs={12}
        sx={{
          backgroundColor: '#F5F5FA',
          width: '100%',
          padding: '1.75em',
          marginLeft:
            isHRView && i18n.language == 'en'
              ? '11em'
              : !isHRView && i18n.language == 'en'
                ? '14em'
                : '',
          marginRight: i18n.language == 'ar' ? '15em' : '',
        }}
      >
        <Grid
          container
          style={{
            paddingLeft: isHRView ? '2em' : '',
          }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={{
              width: '100%',
              height: '80px',
            }}
          >
            <Grid
              container
              style={{
                width: 'auto',
                background: '#FFFFFF 0% 0% no-repeat padding-box',
                borderRadius: '10px',
                opacity: '1',
                display: 'flex',
                flexDirection: 'row',
                paddingTop: '1em',
                paddingBottom: '1em',
                paddingLeft: '1em',
                paddingRight: '1em',
              }}
            >
              <Grid item xs={9}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.header,
                    color: themes.blackDefault,
                    fontWeight: 'bold',
                  }}
                >
                  {trans('Off-Boarding')}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            {!isLoading ? (
              <Grid
                container
                spacing={4}
                style={{
                  width: 'auto',
                }}
              >
                {showForm ? (
                  <Grid item xs={5} sm={5} md={5} lg={5}>
                    <OffBoardingFormController />
                  </Grid>
                ) : (
                  <></>
                )}

                {showHistory ? (
                  <Grid item xs={4} sm={9} md={9} lg={9}>
                    <OffBoardingHistoryController />
                  </Grid>
                ) : (
                  <></>
                )}

                {showWorkflow ? (
                  <Grid item xs={4} sm={4} md={4} lg={4}>
                    <OffBoardingWorkflowController />
                  </Grid>
                ) : (
                  <></>
                )}
              </Grid>
            ) : (
              <Loader />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OffBoardingPresenter;
